// LocalDesktopAccessRequiredModal Component
// Displays a modal when the desktop environment refuses sign-in / switch because the
// account does not have the Revolt Local product access tag. Mirrors the backend
// 403 response from `/api/account/login` + `/api/account/desktop/login` when
// `code === "no_local_desktop_entitlement"`.

import React from 'react';
import { RevoltModal } from './RevoltModal';
import { RevoltButton } from './RevoltButton';

const DEFAULT_MESSAGE =
  'This account does not include Revolt Desktop (Local) access. Purchase or redeem Revolt Local on rvt.dev, then sign in again from the desktop app.';

export function LocalDesktopAccessRequiredModal({
  isOpen,
  onClose,
  message,
  email,
}) {
  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Revolt Desktop access required"
      showCloseButton={true}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            fontSize: '3rem',
            marginBottom: '1rem',
            color: '#f59e0b',
          }}
        >
          <i className="fa-solid fa-shield-halved" aria-hidden />
        </div>

        {email && (
          <p
            style={{
              fontSize: '0.95rem',
              marginBottom: '0.75rem',
              color: '#bbb',
            }}
          >
            <strong>{email}</strong>
          </p>
        )}

        <p
          style={{
            fontSize: '1.05rem',
            marginBottom: '1.5rem',
            color: '#ccc',
            lineHeight: 1.5,
          }}
        >
          {message || DEFAULT_MESSAGE}
        </p>

        <p
          style={{
            fontSize: '0.9rem',
            marginBottom: '2rem',
            color: '#999',
          }}
        >
          You can keep using this account on the website. The desktop app is only
          available to accounts with Revolt Local access.
        </p>

        <RevoltButton
          onClick={onClose}
          variant="primary"
          style={{ minWidth: '120px' }}
        >
          Got it
        </RevoltButton>
      </div>
    </RevoltModal>
  );
}
